import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/logo-white.png';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="container">
        <div>
          <img src={logo} alt="Talentech RDC" />
          <p style={{ maxWidth: '32ch', fontSize: '.9rem' }}>{t('home.footer')}</p>
        </div>
        <div>
          <h4>{t('nav.technicians')}</h4>
          <Link to="/technicians">{t('technician.browseTitle')}</Link>
          <Link to="/register">{t('nav.becomeTechnician')}</Link>
          <Link to="/offres-emploi">{t('nav.jobs')}</Link>
        </div>
        <div>
          <h4>{t('nav.requestService')}</h4>
          <Link to="/service-request">{t('serviceRequest.title')}</Link>
          <Link to="/login">{t('nav.login')}</Link>
          <Link to="/register">{t('nav.signup')}</Link>
        </div>
        <div className="copy">
          © {new Date().getFullYear()} Talentech RDC · République Démocratique du Congo
        </div>
      </div>
    </footer>
  );
}
